const notEquals = (value) => ({
    name: "not-equals",
    validate: (v) => v == null || v === "" || v !== value,
    value,
});
exports.notEquals = notEquals;
